import { ref, defineComponent, computed, onMounted, watch } from "vue";
import FileUpload from "primevue/fileupload";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import Image from "primevue/image";
import { postRequest, uploadRequest, getResource, downloadFile } from "@/assets/utils/utils";
import swal from "sweetalert";
export default defineComponent({
  name: "UploadManyFile",
  components: {
    FileUpload,
    Dropdown,
    Button,
    Image
  },
  props: {
    fileType: {
      type: String
    },
    fileIds: {
      type: Array
    }
  },

  setup(props, context) {
    let file_ids = computed({
      get: () => {
        return props.fileIds;
      },
      set: v => {
        context.emit('update:fileIds', v);
      }
    }); // eslint-disable-next-line

    watch(file_ids, (newVal, oldVal) => {
      load_file_names();
    });
    onMounted(() => {
      load_file_names();
    });
    let files = ref([]);
    let selectedFile = ref(null);

    function load_file_names() {
      if (file_ids.value.length <= 0) return;
      postRequest('/qycommon_api/download/download_base64s', {
        oids: file_ids.value
      }).then(response => {
        files.value = response.data;
      });
    }

    function upload_files(event) {
      /*for (let i = 0; i < event.files.length; i++) {
        let file = event.files[i]
        if (file.size > 1024 * 1024) {
          swal('错误', '文件太大，请上传小于1MB的文件!', 'error')
          return
        }
      }*/
      var formData = new FormData();
      event.files.forEach(file => {
        formData.append('files', file);
      });
      uploadRequest('/qycommon_api/upload/upload_files', formData).then(response => {
        if (response.data.res) {
          swal({
            title: "提示!",
            text: "操作成功!",
            icon: "success",
            button: false,
            timer: 1000
          });
          let oids = file_ids.value;
          oids = oids.concat(response.data.oids);
          file_ids.value = oids;
          selectedFile.value = null;
        } else {
          swal({
            title: "提示!",
            text: "操作失败!",
            icon: "error",
            button: false,
            timer: 1000
          });
        }
      });
    }

    function remove_file() {
      if (!selectedFile.value) return;

      for (let i = 0; i < files.value.length; i++) {
        if (files.value[i].oid === selectedFile.value.oid) {
          files.value.splice(i, 1);
          break;
        }
      }

      let oids = [];

      for (let i = 0; i < files.value.length; i++) {
        oids.push(files.value[i].oid);
      }

      file_ids.value = oids;
      selectedFile.value = null;
    }

    function download_file() {
      if (!selectedFile.value) return;
      getResource(selectedFile.value.oid).then(response => {
        if (response.data.size > 0) {
          downloadFile(selectedFile.value.fileName, response.data);
        }
      });
    }

    return {
      files,
      selectedFile,
      upload_files,
      remove_file,
      download_file
    };
  }

});